import Box from "@mui/material/Box";
import * as React from "react";

import { MetadataForm, MetadataView } from "@/shared/components";
import { AutocompleteType } from "@/shared/components/TagAndMetadataAutocomplete";
import { useUpdateDataset } from "@/shared/domain/datasets/hooks/useUpdateDataset";
import { OrgRecord } from "@/shared/domain/orgs";

interface UpdateDatasetMetadataProps {
  currentOrg: OrgRecord | null;
  datasetId: string;
  metadata: Record<string, string>;
  onError?: (error: Error) => void;
}

export const UpdateDatasetMetadata: React.FC<UpdateDatasetMetadataProps> = ({
  currentOrg,
  datasetId,
  metadata,
  onError,
}) => {
  const updateDatasetMutation = useUpdateDataset();

  const removeField = (key: string) => {
    updateDatasetMutation.mutate(
      {
        datasetId: datasetId,
        resourceOwnerId: currentOrg?.org_id || "",
        updates: {
          metadata_changeset: {
            remove_fields: [key],
          },
        },
      },
      {
        onError: (error: Error) => {
          if (onError) {
            onError(error);
          }
        },
      },
    );
  };

  const addFields = (updates: Record<string, unknown>) => {
    updateDatasetMutation.mutate(
      {
        datasetId: datasetId,
        resourceOwnerId: currentOrg?.org_id || "",
        updates: {
          metadata_changeset: {
            put_fields: updates,
          },
        },
      },
      {
        onError: (error: Error) => {
          if (onError) {
            onError(error);
          }
        },
      },
    );
  };

  return (
    <Box>
      <MetadataView
        metadata={metadata}
        onChange={(metadata: Record<string, unknown>, diff) => {
          if (diff?.keysDeleted && diff.keysDeleted.length > 0) {
            diff.keysDeleted.map(removeField);
          }
          if (diff?.keysUpdated && diff.keysUpdated.length > 0) {
            const putFields: Record<string, unknown> = {};
            for (const k of diff.keysUpdated) {
              putFields[k] = metadata[k];
            }
            addFields(putFields);
          }
        }}
      />
      <MetadataForm
        metadata={metadata}
        autocompleteType={AutocompleteType.ActionMetadataKeys}
        onAddMetadata={(key, value) => addFields({ [key]: value })}
      />
    </Box>
  );
};
